import { render } from "./PatchResult.vue?vue&type=template&id=65fa9db8"
import script from "./PatchResult.vue?vue&type=script&lang=js"
export * from "./PatchResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__